import { useState, useEffect } from "react";
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import Network from "../../../utils/Network";
import { Urls } from "../../../utils/Constants";
import Loader from "../../common/Loader";
import ErrorModal from "../../common/modal/errormodal";
export default function RechargeReport() {
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(0);
  const [errorModalMsg, setErrorModalMsg] = useState("");
  const [dmtData, setDmtData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  

  const openErrorModal = () => setShowErrorModal(1);
  const closeErrorModal = () => setShowErrorModal(0);

  useEffect(() => {
    const todayDate = getDates();
    reportData(todayDate);
  }, [])
  
  const getDates = (selectedFromDate=null,selectedToDate=null) => {
        const today = new Date();
        if(selectedFromDate === null && selectedToDate === null){
        const todayDate = formatDate(today);
        setFromDate(todayDate);
        setToDate(todayDate);
        return todayDate;
        }else{
          return {selectedFromDate,selectedToDate};
        }
    };
  const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
  };

  const reportData = async(defaultDate=null,page=null) => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      if(defaultDate !== null){
        formData.append("fromdate", defaultDate);
        formData.append("todate", defaultDate);
      }else{
        formData.append("fromdate", fromDate);
        formData.append("todate", toDate);
      }
      
      try {
        setLoading(true);
        let response = "";
        if(page === null){
          response = await Network.post(Urls.baseUrlPostLogin + '/report/recharge', formData);
        }else{
          response = await Network.post(Urls.baseUrlPostLogin + '/report/recharge?page='+page, formData);
        }
        if(response?.data?.status === 'success'){
          setDmtData(response.data.data);
          setLastPage(response.data.pagination.last_page);
        }else{
          setErrorModalMsg(response.data.message);
          openErrorModal();
        }
      } catch (err) {
        console.log('error', err);
        setErrorModalMsg(err);
        openErrorModal();
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const fetchDMTReport = () => {
    getDates(fromDate,toDate);
    reportData();
  }
  const handleClickPaginate = (page) => {
    setCurrentPage(page);
    reportData(null,page);
  };
  const downloadReport = async(type) => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("fromdate", fromDate);
      formData.append("todate", toDate);
      formData.append("type", type);
      try {
        setLoading(true);                
        const response = await Network.post(Urls.baseUrlPostLogin + '/report/recharge', formData);
        if(response?.data?.status === 'success'){
          openLinkInNewTab(response.data.url);
        }else{
          setErrorModalMsg(response.data.message);
          openErrorModal();
        }
      } catch (err) {
        console.log('error', err);
        setErrorModalMsg(err);
        openErrorModal();
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const openLinkInNewTab = (url) => {
    window.open(url, '_blank');
  };
  // const exportToCSV = (data, filename = 'data.csv') => {
  //   const csvRows = [];
  //   // Get headers
  //   const headers = Object.keys(data[0]);
  //   csvRows.push(headers.join(','));

  //   // Get rows
  //   data.forEach(row => {
  //     const values = headers.map(header => {
  //       const escaped = ('' + row[header]).replace(/"/g, '""'); // Escape quotes
  //       return `"${escaped}"`;
  //     });
  //     csvRows.push(values.join(','));
  //   });

  //   const csvContent = csvRows.join('\n');

  //   // Create blob and trigger download
  //   const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  //   const url = URL.createObjectURL(blob);

  //   const link = document.createElement('a');
  //   link.setAttribute('href', url);
  //   link.setAttribute('download', filename);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  // const exportToExcel = (data, filename = 'data.xlsx') => {
  //   // Create a new workbook and worksheet
  //   const worksheet = XLSX.utils.json_to_sheet(data);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  //   // Write the workbook as a binary array
  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: 'xlsx',
  //     type: 'array',
  //   });

  //   // Create a blob and trigger the download
  //   const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  //   saveAs(blob, filename);
  // };
  
  return (  
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        {loading ?
          <Loader /> :
          <main
            className="adminuiux-content has-sidebar"
          >
            {/*mt-4*/}
            <div className="container " id="main-content">
              <div className="row align-items-center">
              </div>
              {/* dashboard inner */}
              <div className="midde_cont">
                <div className="container-fluid">
                  <div className="row column_title">
                    <div className="col-md-12">
                      <div className="page_title d-sm-flex">
                        <h2>Recharge Report</h2>
                      </div>
                    </div>
                  </div>
                  <div className="row gutters mt-3">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="card rounded">
                        <div className="card-body">
                          <form
                            method="GET"
                            className=""
                          >
                            <div className="row gutters">
                              <div className="col-md-6">
                                <div className="">
                                  <div className="card-header p-2">Date</div>
                                  <div className="card-body">
                                    <div className="form-group">
                                      <label htmlFor="helperText">From Date</label>
                                      <input
                                        type="date"
                                        id="fromdate"                                        
                                        className="form-control hasDatepicker"
                                        placeholder="From"
                                        autoComplete="off"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                      />
                                    </div>
                                    {errors.fromDate && (
                                        <span className="error-message">
                                            {errors.fromDate}
                                        </span>
                                    )}
                                    <div className="form-group">
                                      <label htmlFor="helperText">To Date</label>
                                      <input
                                        type="date"
                                        id="todate"                                        
                                        className="form-control hasDatepicker"
                                        placeholder="To"
                                        autoComplete="off"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                      />
                                    </div>
                                    {errors.toDate && (
                                        <span className="error-message">
                                            {errors.toDate}
                                        </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <button type="button" className="btn btn-primary" onClick={fetchDMTReport}>
                                  Search
                                </button>&nbsp;
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  value="export"
                                  onClick={()=>downloadReport('excel')}
                                >
                                  Excel
                                </button>&nbsp;
                                <button
                                  type="button"
                                  className="btn btn-primary"                                  
                                  value="export"
                                  onClick={()=>downloadReport('csv')}
                                >
                                  Csv
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="row match-height"
                    id="main_box"
                  >
                    <div className="col-12">
                      <div className="form-body">
                        <div className="row">
                          <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="card adminuiux-card bd-0 shadow-base mt-2">
                              <div
                                className="card-header tx-medium bd-0 tx-white"
                                style={{ padding: "0.75rem 1.25rem" }}
                              >
                                Recharge Report
                              </div>
                              {/* card-header */}
                              <div className="card-body">
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th>Order ID</th>
                                        <th>Date</th>
                                        <th>Service Type</th>
                                        <th>Mobile Number</th>
                                        <th>Bank Name</th>
                                        <th>Name</th>
                                        <th>Account Number</th>
                                        <th>Ifsc</th>
                                        <th>Amount</th>
                                        <th>UTR</th>
                                        <th>Type</th>
                                        <th>Status</th>
                                        {/* <th>Action</th> */}
                                        {/* <th>Refund Otp</th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {dmtData?.map((item)=>(
                                      <tr>
                                        <td>{item.order_id}</td>
                                        <td>{item.date}</td>
                                        <td>{item.service_type}</td>
                                        <td>{item.mobile_number}</td>
                                        <td>{item.bank_name}</td>
                                        <td>{item.name}</td>
                                        <td>{item.account_Number}</td>
                                        <td>{item.ifsc}</td>
                                        <td>{item.amount}</td>
                                        <td>{item.utr}</td>
                                        <td>{item.type}</td>
                                        <td>{item.status}</td>
                                        {/* <td><button className="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="top" title="Print">Print</button></td> */}
                                        {/* <td>{item.mobile_number}</td> */}
                                      </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="mt-3 pull-right">
                                {Array.from({ length: lastPage }, (_, i) => i + 1).map((page) => (                                  
                                  <>
                                  <button
                                    key={page}
                                    onClick={()=>handleClickPaginate(page)}
                                    disabled={currentPage === page}
                                    className="btn btn-primary btn-sm"
                                  >
                                    {page}
                                  </button>
                                  &nbsp;
                                  </>
                                ))}
                                </div>
                              </div>
                            </div>
                            {/* card-body */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showErrorModal === 1 &&
                <ErrorModal
                title="Error"
                closeErrorModal={closeErrorModal}
                errorMsg={errorModalMsg}
                />
              }
            </div>
          </main>
        }
      </div>
    </>

  );
}